import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface DateRangeFilterProps {
  range: string;
  setRange: (value: string) => void;
  fromDate: string;
  setFromDate: (value: string) => void;
  toDate: string;
  setToDate: (value: string) => void;
}

export function DateRangeFilter({
  range,
  setRange,
  fromDate,
  setFromDate,
  toDate,
  setToDate
}: DateRangeFilterProps) {
  return (
    <Grid container gap={3}  alignItems='center' >
    <LocalizationProvider dateAdapter={AdapterDayjs}>
       <Grid item xs={12} md={3}>
        {/* Date Range Select */}
        <FormControl>
          <InputLabel id='date-select-label'>
          Select Date
          </InputLabel>
          <Select
            labelId='date-select-label'
            label='Select Date'
            value={range}
            onChange={e => setRange(e.target.value)}
          >
            <MenuItem value='ALL'>All Time</MenuItem>
            <MenuItem value='LAST_30_DAYS'>Last 30 days</MenuItem>
            <MenuItem value='LAST_60_DAYS'>Last 60 days</MenuItem>
            <MenuItem value='LAST_90_DAYS'>Last 90 days</MenuItem>
            <MenuItem value='CUSTOM'>Custom range</MenuItem>
          </Select>
        </FormControl>
        </Grid>
          <Grid item xs={12} md={3}>
            {range === 'CUSTOM' && (
            <DatePicker
              label='From'
              value={fromDate ? dayjs(fromDate) : null}
              onChange={(newValue) =>
                setFromDate(
                  newValue ? newValue.format('YYYY-MM-DD') : ''
                )
              }
              slotProps={{
                textField: {
                  size: 'medium',
                  sx: { width: 150 }
                }
              }}
            />
            )}
            </Grid>
            <Grid item xs={12} md={3}>
               {range === 'CUSTOM' && (
            <DatePicker
              label='To'
              value={toDate ? dayjs(toDate) : null}
              onChange={(newValue) =>
                setToDate(
                  newValue ? newValue.format('YYYY-MM-DD') : ''
                )
              }
              slotProps={{
                textField: {
                  size: 'medium',
                  sx: { width: 150 }
                }
              }}
            />
            )}
        </Grid>
    </LocalizationProvider>
    </Grid>
  );
}
